module.exports = __webpack_public_path__ + "static/media/b5-white-spanish.7368d8d8.png";